<!-- 开通记账本 -->
<template>
  <div class="open-accountbook-page" data-test="open-accountbook-page">
    <div class="wrap">
      <div class="title">
        欢迎使用记账本
        <div class="t1">机构收支分类记账，校区统计一目了然</div>
      </div>
      <div class="img-wrap">
        <img
          class="img"
          src="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/0003.png"
        />
      </div>
      <div class="tips">
        <div class="tips-title">使用小提示：</div>
        <div>1.辅助人工记账，对机构额外的收支情况进行手动记账；</div>
        <div>2.账目记录灵活，漏记可补充，错记可编辑；</div>
        <div>3.按校区记账，按类型统计，收支构成清晰；</div>
      </div>
    </div>
    <div class="footer">
      <van-button
        square round
        block
        type="primary"
        @click="openAccountbook"
        loading-text="开通中..."
        :loading="isSubmit"
        data-test="open-accountbook-page-btn-to-open"
        >开通记账本</van-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "open-accountbook",
  data() {
    return {
      pageTitle: "记账本",
      isSubmit: false, //提交中
    };
  },
  methods: {
    openAccountbook() {
      this.isSubmit = true;
      this.$api
        .openAccountBook()
        .then((res) => {
          if (res.code == 200) {
            app.teacher.user.companyInfoVo.companyAppOpenList.push(
              "ACCOUNT_BOOK"
            );
            this.$toast.success("开通记账本成功");
            setTimeout(() => {
              this.$router.replace(`/accountbookList`);
            }, 50);
          } else if (res.code == 84001) {
            this.$toast.fail("记账本开通失败，请稍后重试");
          } else {
            this.$toast.fail(res.msg);
          }
        })
        .finally(() => {
          this.isSubmit = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.open-accountbook-page {
  display: flex;
  flex-direction: column;
  background-color: var(--white);
  .wrap {
    flex: 1;
    .title {
      margin: calc(var(--gap) * 40) 0 calc(var(--gap) * 47) 0;
      text-align: center;
      font-size: var(--fs-ex2);
      line-height: var(--lh-ex2);
      color: var(--g8);
      .t1 {
        margin-top: calc(var(--gap) * 4);
        font-size: var(--fs-lg);
        line-height: var(--lh-lg);
      }
    }
    .img-wrap {
      text-align: center;
      .img {
        width: calc(var(--w) * 248);
        height: calc(var(--w) * 248);
      }
    }
    .tips {
      margin: calc(var(--gap) * 47) calc(var(--gap) * 32) calc(var(--gap) * 40)
        calc(var(--w) * 32);
      color: var(--g8);
      font-size: var(--fs-sm);
      line-height: var(--lh-sm);
      .tips-title {
        margin-bottom: calc(var(--gap) * 8);
        color: var(--black);
        font-size: var(--fs-md);
        line-height: var(--lh-md);
      }
    }
  }
  .footer {
    height: calc(var(--w) * 50);
    background: var(--white);
    padding: calc(var(--gap) * 5) calc(var(--gap) * 16);
    display: flex;
    .van-button {
      height: calc(var(--w) * 40);
    }
  }
}
</style>